<template>
  <section class="signup-policy">
    <ServicePolicies
      v-if="!showSignupForms"
      @agree="handleAgree"
    />
    <SignupForms v-else />
  </section>
</template>

<script>
  import SignupForms from '@/components/auth/signup/SignupForms';
  import ServicePolicies from '@/components/auth/signup/ServicePolicies';

  export default {
    components: { SignupForms, ServicePolicies },
    data() {
      return {
        showSignupForms: false,
      };
    },
    methods: {
      handleAgree() {
        this.showSignupForms = true;
      }
    }
  };
</script>